import React, { PropsWithChildren } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import InviteForm from './InviteForm';

interface InviteDialogProps {
  open: boolean;
  onClose(): void;
  onSuccess(): void;
  apiKey: string;
}

function InviteDialog({ open, onClose, onSuccess, apiKey }: PropsWithChildren<InviteDialogProps>) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="sm">
      <DialogContent>
        <InviteForm onSuccess={() => onSuccess()} apiKey={apiKey} />
      </DialogContent>
    </Dialog>
  );
}

export default InviteDialog;
